import React, {useState} from 'react';
import { ChevronLeft, ChevronRight, Settings, Users, Wrench, BarChart2, Cable, FileAudio } from 'lucide-react';

const LeftPanel = ({ isCollapsed, togglePanel, selectedService, onServiceSelect }) => {
  const [isToolsCollapsed, setIsToolsCollapsed] = useState(true); // State for Tools collapse

  const handleToolsToggle = () => {
    setIsToolsCollapsed(!isToolsCollapsed);
  };
  
  const services = [
    { name: 'Agents', icon: <Users size={20} /> },
    { name: 'Tools', icon: <Wrench size={20} />,
    subItems: [
      { name: 'Web Monitoring', icon: <Cable size={20} /> },
      { name: 'Image Generation', icon: <Cable size={20} /> },
      { name: 'Transcription', icon: <FileAudio size={20} /> },
    ], },
    { name: 'Automation', icon: <Wrench size={20} /> },
    { name: 'Marketing', icon: <BarChart2 size={20} /> },
    { name: 'Settings', icon: <Settings size={20} /> },
  ];

  const renderServiceItem = (service) => {
    if (service.subItems) {
      return (
        <div key={service.name}>
          <ServiceItem
            name={service.name}
            icon={service.icon}
            isSelected={selectedService === service.name}
            onClick={handleToolsToggle} // Toggle Tools collapse
          />
          {!isToolsCollapsed && (
            <div className="ms-4">
              {service.subItems.map((subItem) => (
                <ServiceItem
                  key={subItem.name}
                  name={subItem.name}
                  icon={subItem.icon}
                  isSelected={selectedService === subItem.name}
                  onClick={() => onServiceSelect(subItem.name)} // Select sub-item
                />
              ))}
            </div>
          )}
        </div>
      );
    } else {
      return (
        <ServiceItem
          key={service.name}
          name={service.name}
          icon={service.icon}
          isSelected={selectedService === service.name}
          onClick={() => onServiceSelect(service.name)}
        />
      );
    }
  };
  return (
    <div
      className={`bg-dark text-white ${
        isCollapsed ? 'w-auto' : 'w-25'
      } d-flex flex-column transition-all`}
    >
      <div className="p-3 d-flex justify-content-between align-items-center border-bottom border-secondary">
        <h2 className={`fw-medium ${isCollapsed ? 'd-none' : 'd-block'}`}>Services</h2>
        <button
          onClick={togglePanel}
          className="p-1 rounded btn btn-dark"
        >
          {isCollapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
        </button>
      </div>
      <div className="flex-grow-1 overflow-auto">
        <div className="flex-grow-1 overflow-auto">
          {services.map((service) => renderServiceItem(service))}
        </div>
      </div>
    </div>
  );
};

const ServiceItem = ({ name, icon, isSelected, onClick }) => {
  return (
    <div
      className={`p-3 d-flex align-items-center list-group-item list-group-item-action ${
        isSelected ? 'bg-primary' : 'hover:bg-dark'
      }`}
      onClick={onClick}
      style={{ cursor: 'pointer' }} 
    >
      <span className="me-3">{icon}</span>
      <span>{name}</span>
    </div>
  );
};

export default LeftPanel;